import { Scope } from "../types/Scope";
import { ShapeStore } from "../ShapeStore";
import { WBEventAnyPayload } from "../types/WBEvent2";

export enum UndoOrRedo {
  Undo = "undo",
  Redo = "redo",
}

export interface Operation {
  forwardEvents: WBEventAnyPayload[];
  backwardEvents: WBEventAnyPayload[];
  readonly label: string;
  applyBackward: (shapeStore: ShapeStore) => void;
  applyForward: (shapeStore: ShapeStore) => void;
  getIsValid: (undoOrRedo: UndoOrRedo, shapeStore: ShapeStore) => boolean;
}

export class SingleOperation implements Operation {
  // TODO: change data type
  forwardEvents: WBEventAnyPayload[];
  backwardEvents: WBEventAnyPayload[];

  constructor(
    forwardEvents: WBEventAnyPayload[],
    backwardEvents: WBEventAnyPayload[]
  ) {
    this.forwardEvents = forwardEvents;
    this.backwardEvents = backwardEvents;
  }

  get label(): string {
    return "Unknown operation";
  }

  applyBackward(shapeStore: ShapeStore) {
    for (const eventPrototype of this.backwardEvents) {
      shapeStore.send(Scope.Persist, eventPrototype);
    }
  }

  applyForward(shapeStore: ShapeStore) {
    for (const eventPrototype of this.forwardEvents) {
      shapeStore.send(Scope.Persist, eventPrototype);
    }
  }

  getIsValid(undoOrRedo: UndoOrRedo, shapeStore: ShapeStore): boolean {
    if (undoOrRedo == UndoOrRedo.Redo) return true;

    // Only allow undo if no other clients have affected the same object

    for (const e of this.forwardEvents) {
      if (!shapeStore.getIsUndoable(e)) {
        console.log("Discarding operation; another client has touched it");
        return false;
      }
    }
    return true;
  }
}

export class MultiOperation implements Operation {
  constructor(public operations: Operation[]) {}
  get label(): string {
    return this.operations.map((o) => o.label).join(", ");
  }
  get forwardEvents(): WBEventAnyPayload[] {
    return this.operations.map((o) => o.forwardEvents).flat();
  }
  get backwardEvents(): WBEventAnyPayload[] {
    return this.operations.map((o) => o.backwardEvents).flat();
  }
  applyBackward(shapeStore: ShapeStore) {
    for (const o of this.operations) {
      o.applyBackward(shapeStore);
    }
  }
  applyForward(shapeStore: ShapeStore) {
    for (const o of this.operations) {
      o.applyForward(shapeStore);
    }
  }
  getIsValid(undoOrRedo: UndoOrRedo, shapeStore: ShapeStore): boolean {
    for (const o of this.operations) {
      if (!o.getIsValid(undoOrRedo, shapeStore)) return false;
    }
    return true;
  }
}
